//引入vue
import Vue from 'vue';
import local from '@/api/storage.js';
import { isShopifyEmbedded } from '@shopify/app-bridge-utils';

Vue.prototype.$local = local;

export const TOKEN_KEY = 'Seal_';

export const isLocalStorage = () => {
  try {
    localStorage.setItem('key', 'value');
    localStorage.removeItem('key');
    return true;
  } catch {
    return false;
  }
}

export const setToken = (token) => {
  if (isShopifyEmbedded()) {
    Vue.prototype.$local.set(TOKEN_KEY + 'ApiAuth', token);
  } else {
    sessionStorage.setItem(TOKEN_KEY + 'ApiAuth', token)
  }
}

export const getToken = () => {
  let token = !isShopifyEmbedded() ? sessionStorage.getItem(TOKEN_KEY + 'ApiAuth') : JSON.parse(Vue.prototype.$local.get())[TOKEN_KEY + 'ApiAuth'];
  if (token) {
    return token
  } else {
    return false
  }
}

// Mark 存储local信息
export const localSave = (key, value) => {
  if (isShopifyEmbedded()) {
    if (isLocalStorage()) {
      localStorage.setItem(key, value)
    }
    Vue.prototype.$local.set(key, value)
  } else {
    localStorage.setItem(key, value);
  }
}

// Mark 获取local信息
export const localRead = (key) => {
  if (isShopifyEmbedded()) {
    if (isLocalStorage()) {
      return localStorage.getItem(key) || '';
    } else {
      return JSON.parse(Vue.prototype.$local.get())[key] || '';
    }
  } else {
    return localStorage.getItem(key) || '';
  }
}

// Mark 存储session信息
export const sessionSave = (key, value) => {
  if (isShopifyEmbedded()) {
    if (isLocalStorage() && key == 'pro') {
      sessionStorage.setItem(key, value)
    }
    Vue.prototype.$local.set(key, value);
  } else {
    sessionStorage.setItem(key, value);
  }
}

// Mark 获取session信息
export const sessionRead = (key) => {
  if (isShopifyEmbedded()) {
    if (isLocalStorage() && key == 'pro') {
      return sessionStorage.getItem(key) || '';
    } else {
      return JSON.parse(Vue.prototype.$local.get())[key] || '';
    }
  } else {
    return sessionStorage.getItem(key) || '';
  }
}

// Mark 移除session信息
export const sessionRmove = (key) => {
  if (isShopifyEmbedded()) {
    if (isLocalStorage()) {
      return sessionStorage.removeItem(key);
    } else {
      return Vue.prototype.$local.remove(key);
    }
  } else {
    return sessionStorage.removeItem(key);
  }
}

export const setShop = (shop) => {
  if (isShopifyEmbedded()) {
    // 店铺设置
    if (isLocalStorage()) {
      sessionStorage.setItem('shop', shop)
    }
    Vue.prototype.$local.set('shop', shop)
  } else {
    sessionStorage.setItem('shop', shop)
  }
}

export const getShop = () => {
  const shop = !isShopifyEmbedded() ? sessionStorage.getItem('shop') : JSON.parse(Vue.prototype.$local.get())['shop'];
  if (shop) {
    return shop
  } else {
    return false
  }
}

